import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col lg:grid lg:grid-cols-2 gap-y-12 px-6 sm:px-10 gap-x-40" }
const _hoisted_2 = { class: "flex flex-col space-y-8 justify-start" }
const _hoisted_3 = { class: "space-y-4" }
const _hoisted_4 = { class: "space-y-3 text-gray-600 dark:text-gray-400" }
const _hoisted_5 = { class: "flex items-start gap-3" }
const _hoisted_6 = { class: "flex items-start gap-3" }
const _hoisted_7 = { class: "flex items-start gap-3" }
const _hoisted_8 = { class: "flex items-start gap-3" }
const _hoisted_9 = { class: "space-y-4" }
const _hoisted_10 = { class: "pt-2" }
const _hoisted_11 = {
  key: 0,
  class: "space-y-6"
}
const _hoisted_12 = { class: "flex flex-col items-center gap-4" }
const _hoisted_13 = { class: "inline-flex items-center justify-center w-16 h-16 bg-green-100 dark:bg-green-900 rounded-full" }


export default /*@__PURE__*/_defineComponent({
  __name: 'contact-sale',
  setup(__props) {

definePageMeta({
  layout: "default",
});

useHead({
  title: "Get in touch - FamilyAxis",
  meta: [
    {
      name: "description",
      content:
        "Interested in learning more? We're here to listen and show you how FamilyAxis could work for your service.",
    },
  ],
});

defineOgImage("MainOg", {
  title: "Get in touch | FamilyAxis",
  description:
    "Interested in learning more? We're here to listen and show you how FamilyAxis could work for your service.",
  theme: "#bc9fff",
  colorMode: "light",
});

useSeoMeta({
  title: "Get in touch | FamilyAxis",
  description:
    "Interested in learning more? We're here to listen and show you how FamilyAxis could work for your service.",
  keywords:
    "get in touch FamilyAxis, residential family assessment software, safeguarding, observations, reports, UK GDPR",
  author: "FamilyAxis",
  ogTitle: "Get in touch | FamilyAxis",
  ogDescription:
    "Interested in learning more? We're here to listen and show you how FamilyAxis could work for your service.",
  ogUrl: "https://familyaxis.com/contact-sale",
  ogType: "website",
  ogSiteName: "FamilyAxis",
  twitterCard: "summary_large_image",
  twitterTitle: "Get in touch | FamilyAxis",
  twitterDescription:
    "Interested in learning more? We're here to listen and show you how FamilyAxis could work for your service.",
  twitterSite: "@familyaxis",
  robots: "index, follow",
});

const formSubmitted = ref(false);
const toast = useToast();

const handleSuccess = () => {
  formSubmitted.value = true;
  toast.add({
    title: "Thank you!",
    description: "We'll be in touch shortly.",
    color: "green",
    icon: "i-heroicons-check-circle",
  });
};

const handleError = (message: string) => {
  toast.add({
    title: "Error",
    description: message,
    color: "red",
    icon: "i-heroicons-exclamation-triangle",
  });
};

const openHelpEmail = () => {
  // Obfuscated email to prevent spam
  const parts = [
    String.fromCharCode(115, 117, 112, 112, 111, 114, 116),
    String.fromCharCode(64),
    String.fromCharCode(102, 97, 109, 105, 108, 121, 97, 120, 105, 115),
    String.fromCharCode(46),
    String.fromCharCode(99, 111, 109),
  ];
  const email = parts.join("");
  const subject = encodeURIComponent("Help Request - FamilyAxis");
  const body = encodeURIComponent(
    "Hello,\n\nI would like to get in touch regarding FamilyAxis.\n\n",
  );
  const mailtoLink = `mailto:${email}?subject=${subject}&body=${body}`;
  window.location.href = mailtoLink;
};

return (_ctx: any,_cache: any) => {
  const _component_UPageHero = _resolveComponent("UPageHero")!
  const _component_UIcon = _resolveComponent("UIcon")!
  const _component_UPageCard = _resolveComponent("UPageCard")!
  const _component_UButton = _resolveComponent("UButton")!
  const _component_ContactSaleForm = _resolveComponent("ContactSaleForm")!
  const _component_UCard = _resolveComponent("UCard")!
  const _component_UPageBody = _resolveComponent("UPageBody")!
  const _component_UPage = _resolveComponent("UPage")!
  const _component_UContainer = _resolveComponent("UContainer")!

  return (_openBlock(), _createBlock(_component_UContainer, null, {
    default: _withCtx(() => [
      _createVNode(_component_UPage, null, {
        default: _withCtx(() => [
          _createVNode(_component_UPageBody, { class: "pt-16 pb-20" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_UPageHero, {
                    title: "Get in touch",
                    description: "Interested in learning more? We're here to listen and show you how FamilyAxis could work for your service.",
                    ui: {
                container:
                  'flex flex-col lg:grid py-2 sm:py-2 lg:py-2 gap-4 sm:gap-y-4 mx-auto px-0 sm:px-0 lg:px-0',
                wrapper: 'text-left',
              }
                  }),
                  _createVNode(_component_UPageCard, { variant: "soft" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900 dark:text-white" }, " Here's how we can help: ", -1)),
                        _createElementVNode("ul", _hoisted_4, [
                          _createElementVNode("li", _hoisted_5, [
                            _createVNode(_component_UIcon, {
                              name: "i-heroicons-check-circle",
                              class: "h-5 w-5 text-green-600 dark:text-green-400 mt-0.5 shrink-0"
                            }),
                            _cache[0] || (_cache[0] = _createElementVNode("span", null, "Book a relaxed introduction to see how FamilyAxis works", -1))
                          ]),
                          _createElementVNode("li", _hoisted_6, [
                            _createVNode(_component_UIcon, {
                              name: "i-heroicons-check-circle",
                              class: "h-5 w-5 text-green-600 dark:text-green-400 mt-0.5 shrink-0"
                            }),
                            _cache[1] || (_cache[1] = _createElementVNode("span", null, "Schedule a full, live demo to explore the software in-depth", -1))
                          ]),
                          _createElementVNode("li", _hoisted_7, [
                            _createVNode(_component_UIcon, {
                              name: "i-heroicons-check-circle",
                              class: "h-5 w-5 text-green-600 dark:text-green-400 mt-0.5 shrink-0"
                            }),
                            _cache[2] || (_cache[2] = _createElementVNode("span", null, "Get friendly, tailored pricing for your organisation's size", -1))
                          ]),
                          _createElementVNode("li", _hoisted_8, [
                            _createVNode(_component_UIcon, {
                              name: "i-heroicons-check-circle",
                              class: "h-5 w-5 text-green-600 dark:text-green-400 mt-0.5 shrink-0"
                            }),
                            _cache[3] || (_cache[3] = _createElementVNode("span", null, "Discuss setup, training and support for your team", -1))
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_UPageCard, { variant: "subtle" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900 dark:text-white" }, " Ready to learn more? ", -1)),
                        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400" }, " Fill out the form and a member of our team will be in touch to arrange a time. ", -1)),
                        _createElementVNode("div", _hoisted_10, [
                          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-sm text-gray-600 dark:text-gray-400 mb-3" }, [
                            _createElementVNode("strong", null, "Prefer email?")
                          ], -1)),
                          _createVNode(_component_UButton, {
                            color: "primary",
                            variant: "outline",
                            icon: "i-heroicons-envelope",
                            onClick: openHelpEmail
                          }, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                              _createTextVNode(" Help Email ", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", null, [
                  (!_unref(formSubmitted))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(_component_ContactSaleForm, {
                          onSuccess: handleSuccess,
                          onError: handleError
                        })
                      ]))
                    : (_openBlock(), _createBlock(_component_UCard, {
                        key: 1,
                        class: "text-center py-12"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_UIcon, {
                                name: "i-heroicons-check-circle",
                                class: "h-8 w-8 text-green-600 dark:text-green-400"
                              })
                            ]),
                            _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "text-2xl font-bold text-gray-900 dark:text-white" }, " Thank you for your interest! ", -1)),
                            _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400 max-w-md" }, " We've received your request and a member of our team will contact you shortly. ", -1)),
                            _createVNode(_component_UButton, {
                              to: "/",
                              color: "primary",
                              variant: "solid",
                              class: "mt-4"
                            }, {
                              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                _createTextVNode(" Return to homepage ", -1)
                              ]))]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }))
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})